import { IColor } from '../ColorModal';
import { ColorNameLabel, Container } from './PopularColorCard.styled';
import { getContrastingLabelColor } from 'utils/colorUtils';
import Tooltip from 'components/Tooltip/Tooltip';
import { formatPrice } from '../ColorCard/helpers';
import { useTranslation } from 'react-i18next';
import { useCurrencySymbol } from 'utils/hooks/useFormatMoney';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { ColorCode } from '../ColorCard/ColorCard.styled';
import { getColorBackground } from '../helpers';

interface IPopularColorCardProps {
  isSelected: boolean;
  color: IColor;
  handleChooseColor: (color: IColor) => void;
}

const PopularColorCard = ({
  isSelected,
  color,
  handleChooseColor,
}: IPopularColorCardProps) => {
  const { t } = useTranslation();

  const { currency } = useSelector(
    (state: IRootReducerState) => state.shoppingCartInfo
  );

  const currencySymbol = useCurrencySymbol(currency);

  const { darkMode } = useSelector(
    (state: IRootReducerState) => state.commonInfo
  );
  const bgColor = getColorBackground(color, darkMode);

  return (
    <Tooltip content={formatPrice(color.additional_price, t, currencySymbol)}>
      <Container
        isSelected={isSelected}
        bgColor={bgColor}
        onClick={() => handleChooseColor(color)}
      >
        <ColorNameLabel color={getContrastingLabelColor(bgColor)}>
          {color.name}
        </ColorNameLabel>
        {color.code ? <ColorCode>({color.code})</ColorCode> : null}
      </Container>
    </Tooltip>
  );
};

export default PopularColorCard;
